import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgLibrary = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.24994 2.9375C3.24994 3.45703 3.66791 3.875 4.18744 3.875H19.8124C20.332 3.875 20.7499 3.45703 20.7499 2.9375C20.7499 2.41797 20.332 2 19.8124 2H4.18744C3.66791 2 3.24994 2.41797 3.24994 2.9375ZM3.87494 8.25C3.33588 8.25 2.82416 8.48047 2.46869 8.88281C2.11322 9.28516 1.94916 9.82422 2.01557 10.3594L3.26557 20.3594C3.38276 21.2969 4.17963 22 5.12494 22H18.8749C19.8203 22 20.6171 21.2969 20.7343 20.3594L21.9843 10.3594C22.0507 9.82422 21.8867 9.28906 21.5312 8.88672C21.1757 8.48438 20.664 8.25391 20.1249 8.25391H3.87494V8.25ZM19.1874 15.4375C19.1874 18.3711 15.9687 20.75 11.9999 20.75C8.03119 20.75 4.81244 18.3711 4.81244 15.4375C4.81244 12.5039 8.03119 10.125 11.9999 10.125C15.9687 10.125 19.1874 12.5039 19.1874 15.4375ZM11.9999 16.6875C12.6913 16.6875 13.2499 16.2695 13.2499 15.75C13.2499 15.2305 12.6913 14.8125 11.9999 14.8125C11.3085 14.8125 10.7499 15.2305 10.7499 15.75C10.7499 16.2695 11.3085 16.6875 11.9999 16.6875ZM3.56244 5.125C3.04291 5.125 2.62494 5.54297 2.62494 6.0625C2.62494 6.58203 3.04291 7 3.56244 7H20.4374C20.957 7 21.3749 6.58203 21.3749 6.0625C21.3749 5.54297 20.957 5.125 20.4374 5.125H3.56244Z", fill: props.fill }));
});
export default SvgLibrary;
